export default "__VITE_ASSET__BkUBhBFJ__"